  <div class="header-wrapper">
    <mat-chip-set>
      @if (company?.image && !companyService.loading) {
      <mat-chip
        disabled
        class="company-img"
        [ngStyle]="{ 'background-image': 'url(' + company?.image + ')' }"
      ></mat-chip>
      }
      @if (!company?.image && !companyService.loading) {
      <mat-chip class="company-initials" disabled>{{
        companyInitials
      }}</mat-chip>
      }
      @if (companyService.loading) {
      <mat-chip class="company-initials" disabled></mat-chip>
      }
    </mat-chip-set>
    @if (!companyService.loading) {
    <div class="details">
      <p class="company-name">{{ company?.name }}</p>
      <p class="mat-subtitle-1">{{ displayAddress }}</p>
      <p class="mat-subtitle-1">
        {{ 'Sector_Number' | translate }}: {{ company?.sectorNumber }}
      </p>
    </div>
    }
  </div>
